import * as React from 'react';
import { CookiesProvider } from 'react-cookie';

import { SpinnerContainer } from './common/components/spinner/spinnerContainer';
import { Footer } from './components/shared/footer';
import { Header } from './components/shared/header';

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import './main.css';

export const App: React.StatelessComponent<{}> = (props) => {
  return (
      <CookiesProvider>
        <SpinnerContainer />
        <Header />
          {props.children}
        <Footer />
      </CookiesProvider>
  );
}


// WEBPACK FOOTER //
// ./src/App.tsx